/**
 * Utility functions for page config related functionality in search
 */
import SearchExperiments from 'bundles/epic/clients/search';

/**
 * List of queries that should use the page config system for free content experience
 */
export const FREE_QUERIES = ['free', 'free courses', 'free certificate', 'free certification', 'learn for free'];

/**
 * Determines if a search query should use the page config system for free content
 */
export const isFreeQuery = (query?: string): boolean => {
  if (!query) return false;
  const normalizedQuery = query.trim().toLowerCase();
  return FREE_QUERIES.includes(normalizedQuery);
};

/**
 * Mock function to check if the search page config feature is enabled
 * This would be replaced with actual epic implementation
 */
export const isSearchPageConfigEnabled = (): boolean => {
  return SearchExperiments.get('freeQuery') === true;
};

/**
 * Determines if a search should use the page config system
 * based on query content and experiment status, impress only if they are part of FREE_QUERIES
 */
export const shouldUseSearchPageConfig = (query?: string): boolean => {
  return isFreeQuery(query) && isSearchPageConfigEnabled();
};
